import {SafeBridgeServices} from "./safe-bridge-services";
import {SafeBridgeNewSearchTypesConstants} from "./safe-bridge-types";
import moment from "moment";

export const safeBridgeSearchConstant = "2001-01-01T10:57:02.444Z";

export const staticSafeBridgeSearchData = {
    "count": true,
    "skip": 0,
    "top": 10,
    "searchMode": "any",
    "queryType": "simple",
    "filter": "",
    "facets": [
        "NameOfCompound,count:50,sort:count",
        "MethodReportNumber,count:50,sort:count",
        "AnalyticalMethod,count:50,sort:count",
        "QuantificationLimit,count:50,sort:count",
        "DatePublished,values:" + safeBridgeSearchConstant + "|" + moment().toDate().toISOString()
    ],
    "search": "*"
}

export const getSafeBridgeAzureSearchData = (requestBody) => {
    let safeBridgeRequestBody = Object.assign({}, requestBody, {"top": 5000, "skip": 0})
    return (dispatch) => {
        SafeBridgeServices.searchForGeneralData(safeBridgeRequestBody).then(response => {
            dispatch({
                type: SafeBridgeNewSearchTypesConstants.LAST_SAFE_BRIDGE_SEARCH,
                payload: requestBody
            })

            dispatch({
                type: SafeBridgeNewSearchTypesConstants.SAFE_BRIDGE_AZURE_SEARCH,
                payload: response,
                lastQuery: requestBody
            })
        })
    }
}
